import { AnyAction } from '@reduxjs/toolkit'

import type { FetchStatusCommon } from 'restApi/types'

import type { MyListingData } from './myListingReducer'

type MyListingsState = FetchStatusCommon & {
  data: MyListingData[]
}

const initialState: MyListingsState = {
  data: null,
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  error: null,
  submitting: false,
}

export default function reducer(
  state = initialState,
  action: AnyAction
): MyListingsState {
  switch (action.type) {
    case 'MY_LISTINGS_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'MY_LISTINGS_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: action.payload,
      }

    case 'MY_LISTINGS_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }

    case 'MY_LISTINGS_FETCH_SILENT_PENDING':
      return {
        ...state,
        updating: true,
      }

    case 'MY_LISTINGS_FETCH_SILENT_REJECTED':
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    case 'MY_LISTINGS_FETCH_SILENT_FULFILLED':
      return {
        ...state,
        updating: false,
        updated: true,
        data: action.payload.data,
      }

    default:
      return state
  }
}
